var React = require('react');

function GasFlame (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.9998 3.25V3.62917C12.9998 5.3625 11.9707 6.87917 10.454 7.58333C8.44984 8.50417 7.0415 10.4542 7.0415 12.7292C7.0415 15.8708 9.69567 18.4167 12.9998 18.4167V18.0375C12.9998 16.3042 14.029 14.7875 15.5457 14.0833C17.5498 13.1625 18.9582 11.2125 18.9582 8.9375C18.9582 5.79583 16.304 3.25 12.9998 3.25Z","fill":"#0A9828","key":0}),React.createElement("path",{"opacity":"0.3","d":"M4.875 20.5833V22.75H21.125V20.5833H4.875Z","fill":"#0A9828","key":1})]);
}

GasFlame.defaultProps = {"viewBox":"0 0 26 26","fill":"none"};

module.exports = GasFlame;

GasFlame.default = GasFlame;
